import { render, staticRenderFns } from "./ViewControls.vue?vue&type=template&id=583bdf06&scoped=true&"
import script from "./ViewControls.vue?vue&type=script&lang=js&"
export * from "./ViewControls.vue?vue&type=script&lang=js&"
import style0 from "./ViewControls.vue?vue&type=style&index=0&id=583bdf06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583bdf06",
  null
  
)

export default component.exports